import React from 'react';

interface OffersTagProps {
  size?: 'small' | 'large';
}

const OffersTag: React.FC<OffersTagProps> = ({ size = 'large' }) => {
  if (size === 'small')
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 16"
        fill="none"
      >
        <rect width="16" height="16" transform="translate(0 0.5)" fill="white" fillOpacity="0.01" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 2.5V5.72L15 7.72V8.28L13 10.28V13.5H9.78L7.78 15.5H7.22L5.22 13.5H2V10.28L0 8.28V7.72L2 5.72V2.5H5.22L7.22 0.5H7.78L9.78 2.5H13ZM6 6C6 6.27614 5.77614 6.5 5.5 6.5C5.22386 6.5 5 6.27614 5 6C5 5.72386 5.22386 5.5 5.5 5.5C5.77614 5.5 6 5.72386 6 6ZM7 6C7 6.82843 6.32843 7.5 5.5 7.5C4.67157 7.5 4 6.82843 4 6C4 5.17157 4.67157 4.5 5.5 4.5C6.32843 4.5 7 5.17157 7 6ZM10.1464 4.64648L4.14642 10.6465L4.85353 11.3536L10.8535 5.35359L10.1464 4.64648ZM9.5 10.5C9.77614 10.5 10 10.2761 10 10C10 9.72386 9.77614 9.5 9.5 9.5C9.22386 9.5 9 9.72386 9 10C9 10.2761 9.22386 10.5 9.5 10.5ZM9.5 11.5C10.3284 11.5 11 10.8284 11 10C11 9.17157 10.3284 8.5 9.5 8.5C8.67157 8.5 8 9.17157 8 10C8 10.8284 8.67157 11.5 9.5 11.5Z"
          fill="#333333"
        />
      </svg>
    );
  // Large
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 3V7.98L23 10.98V12.02L20 15.02V20H15.02L12.02 23H10.98L7.98 20H3V15.02L0 12.02V10.98L3 7.98V3H7.98L10.98 0H12.02L15.02 3H20ZM9 7C7.9 7 7 7.9 7 9C7 10.1 7.9 11 9 11C10.1 11 11 10.1 11 9C11 7.9 10.1 7 9 7ZM7.64 14.64L8.35 15.35L15.35 8.35L14.64 7.64L7.64 14.64ZM12 14C12 15.1 12.9 16 14 16C15.1 16 16 15.1 16 14C16 12.9 15.1 12 14 12C12.9 12 12 12.9 12 14ZM9 10C9.55228 10 10 9.55228 10 9C10 8.44771 9.55228 8 9 8C8.44771 8 8 8.44771 8 9C8 9.55228 8.44771 10 9 10ZM14 15C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13C13.4477 13 13 13.4477 13 14C13 14.5523 13.4477 15 14 15Z"
        fill="#333333"
      />
    </svg>
  );
};

export default OffersTag;
